import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentesGlobalesModule } from 'app/componentes-globales/componentes-globales.module';
import { SharedModule } from 'app/shared/shared.module';
import { RepConcarComponent } from './rep-concar/rep-concar.component';
import { StockCarteraComponent } from './stock-cartera/stock-cartera.component';
import {DesembolsosOperacionesComponent } from './desembolsos-operaciones/desembolsos-operaciones.component';
import { CancelacionesOperacionesComponent } from './cancelaciones-operaciones/cancelaciones-operaciones.component';
import { DevolucionRetencionesComponent } from './devolucion-retenciones/devolucion-retenciones.component';
import { StockRetencionesComponent } from './stock-retenciones/stock-retenciones.component';
import { MatAutocompleteModule } from '@angular/material';


@NgModule({
  declarations: [
    RepConcarComponent,
    StockCarteraComponent,
    DesembolsosOperacionesComponent,
    CancelacionesOperacionesComponent,
    DevolucionRetencionesComponent,
    StockRetencionesComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ComponentesGlobalesModule,MatAutocompleteModule
  ],
  exports: [
    RepConcarComponent
  ]
})
export class RepFinanzasModule { }
